import ReactCountryFlag from "react-country-flag";

import MobileDetailsDrawer from "common/components/MobileDetailsDrawer";
import MobileDetailsDrawerItem from "common/components/MobileDetailsDrawer/MobileDetailsDrawerItem";
import { DrawerTitle } from "common/components/ui/Drawer";
import { Tag } from "common/components/ui/Tag";
import { decodeProxyUrl } from "common/helpers/utils";
import type { CustomProxy } from "common/types";

import { PROXY_ACTIONS } from "../../../constants";
import ProxyActions from "../ProxyActions";

interface WebhookMobilePreviewProps {
  proxy: CustomProxy;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export default function MobilePreview({
  proxy,
  isOpen,
  setIsOpen,
}: WebhookMobilePreviewProps) {
  const { url, location, valid: isValid } = proxy;
  const { protocol, address, password, username } = decodeProxyUrl(url);

  return (
    <MobileDetailsDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      editOptions={PROXY_ACTIONS}
      renderEditComponent={(action, onBack) => (
        <ProxyActions
          proxy={proxy}
          action={action}
          onBack={onBack}
          onClose={() => setIsOpen(false)}
        />
      )}
      editTitle="Proxy options"
    >
      <DrawerTitle>{proxy.name}</DrawerTitle>
      <MobileDetailsDrawerItem label="Url">
        {protocol}://{address}
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Authentication">
        {username && password ? `**************` : "-"}
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Location">
        {location ? (
          <Tag variant="tertiary">
            <ReactCountryFlag countryCode={location.countryISO} />
            {location.city || location.country}
          </Tag>
        ) : (
          "-"
        )}
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Status">
        {isValid ? (
          <Tag variant="success">Valid</Tag>
        ) : (
          <Tag variant="disabled">Invalid</Tag>
        )}
      </MobileDetailsDrawerItem>
    </MobileDetailsDrawer>
  );
}
